const LetterLogo = ({ width = 24, height = 24, fill = '#B1B1B1' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5531 3.99994C21.4622 3.99058 21.3706 3.99058 21.2798 3.99994H2.6131C2.49346 4.00179 2.37462 4.01972 2.25977 4.05328L11.8931 13.6466L21.5531 3.99994Z"
      fill={fill}
    />
    <path
      d="M22.54 4.92664L12.8333 14.5933C12.5835 14.8416 12.2455 14.981 11.8933 14.981C11.541 14.981 11.2031 14.8416 10.9533 14.5933L1.33329 4.99997C1.30371 5.10866 1.28803 5.22067 1.28662 5.3333V18.6666C1.28662 19.0203 1.4271 19.3594 1.67715 19.6094C1.92719 19.8595 2.26633 20 2.61995 20H21.2866C21.6402 20 21.9794 19.8595 22.2294 19.6094C22.4795 19.3594 22.62 19.0203 22.62 18.6666V5.3333C22.6146 5.19441 22.5877 5.05719 22.54 4.92664ZM3.53329 18.6666H2.60662V17.7133L7.45329 12.9066L8.39329 13.8466L3.53329 18.6666ZM21.2733 18.6666H20.34L15.48 13.8466L16.42 12.9066L21.2666 17.7133L21.2733 18.6666Z"
      fill={fill}
    />
  </svg>
);

export default LetterLogo;
